import { grey } from '@mui/material/colors';

import { colorsets } from '@/charts/common';

/*
    There are 6 colors in colorsets
    We are grouping spotterids into a max of 6: 6 named spotters or 5 + 'Other'
    Always starting from the first color for the named spotters and using grey for 'Other'
 */
export const pickColors = (spotterids: string[]): string[] => {
    const pickedColors: string[] = [];
    const colors = Object.values(colorsets).map((set) => set.line);
    const hasOther = spotterids.includes('Other');

    for (let i = 0; i < spotterids.length; i++) {
        if (spotterids[i] === 'Other') {
            pickedColors.push(grey[500]);
        } else {
            const index = hasOther ? (i % colors.length) - 1 : i % colors.length;
            pickedColors.push(colors[index]);
        }
    }
    return pickedColors;
};
